export const InventoryTab = {
    operations: 'operations',
    pharmacyInventory: 'pharmacyInventory',
    protocolInventory: 'protocolInventory',
    laboratoryKitInventory: 'laboratoryKitInventory',
    pharmacy: 'pharmacy',
    inventoryReportLog: 'inventoryReportLog'
};

const INVENTORY_ROOT = '/admin/inventory';

const KNOWN_TABS = [
    InventoryTab.operations,
    InventoryTab.pharmacyInventory,
    InventoryTab.protocolInventory,
    InventoryTab.laboratoryKitInventory,
    InventoryTab.pharmacy,
    InventoryTab.inventoryReportLog
];

const TAB_BY_ITEM_ORIGIN: { [origin: string]: string } = {
    pharmacy: InventoryTab.pharmacyInventory,
    protocol: InventoryTab.protocolInventory,
    laboratorykit: InventoryTab.laboratoryKitInventory
};

function toTabKey(tab: unknown): string {
    return (tab ?? '').toString();
}

export function isInventoryTab(tab: unknown): boolean {
    return KNOWN_TABS.indexOf(toTabKey(tab)) >= 0;
}

export function resolveInventoryTab(tab: unknown): string {
    return isInventoryTab(tab) ? toTabKey(tab) : InventoryTab.operations;
}

export function inventoryTabTarget(tab: unknown): string {
    return isInventoryTab(tab) ? `${INVENTORY_ROOT}/section/${toTabKey(tab)}` : INVENTORY_ROOT;
}

export function itemDetailTabTarget(origin: unknown): string {
    return inventoryTabTarget(TAB_BY_ITEM_ORIGIN[toTabKey(origin).toLowerCase()]);
}
